import classNames from 'classnames'
import React from 'react'
import SVGIcon from '../../svg/SVGIcon'
import s from './PoiMarkerHTML.less'

const PoiMarkerHTML = ({ isCurrent, icon, color, src, price, priceColor, visited }) => (
  <div className={classNames(s.root, isCurrent && s.active, visited && s.visited)}>
    <div className={s.tip} />
    <div className={s.content}>
      {icon && (
        <div className={s.icon} style={{ backgroundColor: color }}>
          <SVGIcon icon={icon} />
        </div>
      )}
      {src && (
        <div className={s.image}>
          <img src={src} />
        </div>
      )}
      {price && (
        <div className={s.price} style={{ backgroundColor: priceColor }}>
          <span>{price}</span>
        </div>
      )}
    </div>
  </div>
)

export default PoiMarkerHTML
